import isVerifyTokenGuard from "@/guards/verifyTokenGuard";

export default {
    name: 'classifications',
    component: () => import(/* webpackChunkName: "base-layout" */ '@/layouts/BaseLayout.vue'),
    children: [
        {
            path: '',
            name: 'classifications-index',
            beforeEnter: [isVerifyTokenGuard],
            meta: {
                breadcrumbs: [                    
                    {                           
                        transKey: 'breadcrumbs.classifications-index',
                        isActive: true
                    }
                ]
            },
            component: () => import(/* webpackChunkName: "classifications-index" */ '@/modules/configurations/catalogs/classifications/views/Index.vue')
        },
        {
            path: 'create',
            name: 'classifications-create',
            beforeEnter: [isVerifyTokenGuard],
            meta: {
                breadcrumbs: [
                    {   
                        route: {
                            name: 'classifications-index',
                            params: {}
                        },
                        transKey: 'breadcrumbs.classifications-index',
                        isActive: false
                    },
                    {                           
                        transKey: 'breadcrumbs.classifications-create',
                        isActive: true
                    }
                ]
            },
            component: () => import(/* webpackChunkName: "classifications-create" */ '@/modules/configurations/catalogs/classifications/views/Create.vue')
        },
        {
            path: 'edit/:id',
            name: 'classifications-edit',
            beforeEnter: [isVerifyTokenGuard],
            meta: {
                breadcrumbs: [
                    {   
                        route: {
                            name: 'classifications-index',
                            params: {}
                        },
                        transKey: 'breadcrumbs.classifications-index',
                        isActive: false
                    },
                    {                           
                        transKey: 'breadcrumbs.classifications-edit',
                        isActive: true
                    }
                ]
            },
            component: () => import(/* webpackChunkName: "classifications-edit" */ '@/modules/configurations/catalogs/classifications/views/Edit.vue')
        }
    ]
}